import api from "PFCore/api";

import { MarketplaceSavedParams } from "./marketplace.types";

export const createMarketplaceSaved = (data: MarketplaceSavedParams) =>
  api({
    url: "marketplace/saved",
    method: "POST",
    data
  });
